import { useRecoilValue } from 'recoil';
import { OnlineSalesUnauthenticated } from 'gw-edge-client';
import type { OnlineActivityDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/activity';
import { jobInfoAtom } from '../recoil/atoms/jobInfoAtom';
import { isLoggedOnSelector } from '../recoil/selectors/isLoggedOnSelector';

export const useCreateActivityHook = (): {
    createActivity: (onlineActivity: OnlineActivityDTO) => Promise<void>;
} => {
    const { jobNumber, sessionId } = useRecoilValue(jobInfoAtom);
    const isLoggedOn = useRecoilValue(isLoggedOnSelector);

    const createActivity = async (onlineActivity: OnlineActivityDTO): Promise<void> => {
        await OnlineSalesUnauthenticated.createActivity(
            jobNumber,
            sessionId,
            onlineActivity,
            !isLoggedOn
        );
    };

    return { createActivity };
};
